import Image from "next/image";

interface AvatarImageProps {
  imageUrl?: string;
  label: string;
  resolution: number;
  size: number;
  ring?: boolean;
  textSize?: string;
}

export default function AvatarImage({
  imageUrl,
  label,
  resolution,
  size,
  ring = true,
  textSize = "text-lg",
}: AvatarImageProps) {
  return (
    <>
      {imageUrl ? (
        <Image
          className={`h-${size} w-${size} rounded-full ${
            ring ? "ring-1 ring-gray-300" : null
          }`}
          src={imageUrl}
          alt={label}
          height={resolution}
          width={resolution}
        />
      ) : (
        <div
          className={`h-${size} w-${size} ${textSize} flex items-center justify-center rounded-full bg-gray-200 text-[11px] font-semibold text-gray-500 dark:bg-gray-700`}
        >
          {label.charAt(0).toUpperCase()}
        </div>
      )}
    </>
  );
}
